/* =========================================================
   Biçiçek theme JS — sepet çekmecesi, quick add, varyant,
   upsell/cross-sell. Shopify AJAX Cart API kullanır.
   ========================================================= */
(function () {
  "use strict";

  var settings = window.theme || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Para formatı ---------- */
  function formatMoney(cents) {
    var format = settings.moneyFormat || "{{amount}} TL";
    var amount = (cents / 100).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString("tr-TR"))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var el = qs(".toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "toast";
      el.setAttribute("role", "status");
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add("is-visible"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("is-visible"); }, 2600);
  }

  /* ---------- Cart API ---------- */
  function getCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "Sepete eklenemedi"); });
      return r.json();
    });
  }
  function changeLine(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Drawer ---------- */
  var drawerScrollState = null;
  function lockDrawerScroll() {
    if (drawerScrollState) return;
    drawerScrollState = { x: window.scrollX, y: window.scrollY };
    document.body.style.setProperty("--cart-scroll-y", -drawerScrollState.y + "px");
    document.documentElement.classList.add("cart-scroll-locked");
    document.body.classList.add("cart-scroll-locked");
  }
  function unlockDrawerScroll() {
    if (!drawerScrollState) return;
    var saved = drawerScrollState;
    drawerScrollState = null;
    document.documentElement.classList.remove("cart-scroll-locked");
    document.body.classList.remove("cart-scroll-locked");
    document.body.style.removeProperty("--cart-scroll-y");
    window.scrollTo({ left: saved.x, top: saved.y, behavior: "instant" });
  }
  function openDrawer() {
    var d = qs("[data-cart-drawer]"), o = qs("[data-drawer-overlay]");
    if (!d) return;
    lockDrawerScroll();
    d.classList.add("is-open");
    if (o) o.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
  }
  function closeDrawer() {
    var d = qs("[data-cart-drawer]"), o = qs("[data-drawer-overlay]");
    if (!d) return;
    d.classList.remove("is-open");
    if (o) o.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    unlockDrawerScroll();
  }

  function freeShippingHTML(total) {
    var threshold = settings.freeShippingThreshold || 0;
    if (threshold <= 0) return "";
    var remaining = threshold + 1 - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var msg = remaining > 0
      ? (settings.strings.remaining || "").replace("[amount]", "<strong>" + formatMoney(remaining) + "</strong>")
      : settings.strings.unlocked || "";
    return (
      '<div class="free-shipping-bar"><p>' + msg + "</p>" +
      '<div class="free-shipping-bar__track"><div class="free-shipping-bar__fill" style="width:' + pct + '%"></div></div></div>'
    );
  }

  function drawerLineHTML(item, index) {
    var variant = item.variant_title && item.variant_title !== "Default Title"
      ? '<p class="variant">' + item.variant_title + "</p>" : "";
    var img = item.image
      ? item.image.replace(/(\.[a-z]+)(\?.*)?$/, "_240x$1$2") : "";
    return (
      '<div class="cart-line" data-line="' + (index + 1) + '">' +
        (img ? '<img src="' + img + '" alt="' + item.product_title + '" width="96" height="120">' : "") +
        '<div class="cart-line__info">' +
          '<h3><a href="' + item.url + '">' + item.product_title + "</a></h3>" + variant +
          '<div class="price">' + formatMoney(item.final_price) + "</div>" +
          '<div class="cart-line__controls">' +
            '<div class="qty">' +
              '<button type="button" data-qty-change data-line="' + (index + 1) + '" data-dir="-1" aria-label="Azalt">−</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-qty-input data-line="' + (index + 1) + '" aria-label="Adet">' +
              '<button type="button" data-qty-change data-line="' + (index + 1) + '" data-dir="1" aria-label="Arttır">+</button>' +
            "</div>" +
            '<button type="button" class="cart-line__remove" data-remove data-line="' + (index + 1) + '">Kaldır</button>' +
          "</div>" +
        "</div>" +
        '<div class="cart-line__total">' + formatMoney(item.final_line_price) + "</div>" +
      "</div>"
    );
  }

  function escapeHTML(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  /* Not alanı gövdenin içinde yeniden basıldığı için, kullanıcı yazarken sepet
     güncellenirse yazdığı metin uçmasın diye mevcut değer korunur. */
  var cartUi = settings.cartUi || {};
  var cartWrite = Promise.resolve();
  var discountBusy = false;
  var checkoutBusy = false;
  var latestCart = null;
  function updateCart(data) {
    var request = cartWrite.catch(function () {}).then(function () {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data)
      }).then(function (r) { if (!r.ok) throw new Error(cartUi.discount_error); return r.json(); });
    });
    cartWrite = request;
    return request;
  }
  var invoiceDraft = null;
  var invoiceSaveTimer;
  function saveInvoiceDraft(box) {
    clearTimeout(invoiceSaveTimer);
    return updateCart({ attributes: invoiceAttributes() }).then(function () {
      if (!qs('[data-invoice-field][aria-invalid="true"]')) invoiceStatus(box.dataset.saved, false);
    }).catch(function () { invoiceStatus(box.dataset.saveError, true); });
  }
  var invoiceKeys = ["Şirket unvanı", "Vergi dairesi", "Vergi numarası", "Kurumsal fatura adresi", "Kurumsal fatura ili", "Kurumsal fatura ilçesi"];
  function invoiceFromCart(cart) {
    var a = cart.attributes || {};
    var values = {};
    invoiceKeys.forEach(function (key) { values[key] = a[key] || ""; });
    return { enabled: a["Fatura türü"] === "Kurumsal", values: values };
  }

  function paintInvoice(root) {
    if (!invoiceDraft) return;
    qsa("[data-invoice]", root || document).forEach(function (box) {
      var toggle = qs("[data-invoice-toggle]", box);
      toggle.checked = invoiceDraft.enabled;
      toggle.toggleAttribute("checked", invoiceDraft.enabled);
      qs("[data-invoice-fields]", box).hidden = !invoiceDraft.enabled;
      qsa("[data-invoice-field]", box).forEach(function (input) {
        input.value = invoiceDraft.values[input.dataset.invoiceField] || "";
        if (input.tagName === "TEXTAREA") input.textContent = input.value;
        else input.setAttribute("value", input.value);
        input.disabled = !invoiceDraft.enabled;
        input.setAttribute("aria-required", invoiceDraft.enabled ? "true" : "false");
        if (!invoiceDraft.enabled) input.removeAttribute("aria-invalid");
      });
    });
  }
  function captureInvoice(box) {
    if (!box) return;
    invoiceDraft = { enabled: qs("[data-invoice-toggle]", box).checked, values: {} };
    qsa("[data-invoice-field]", box).forEach(function (input) { invoiceDraft.values[input.dataset.invoiceField] = input.value; });
  }
  function invoiceAttributes() {
    var d = invoiceDraft || { enabled: false, values: {} }, attrs = { "Fatura türü": d.enabled ? "Kurumsal" : "Bireysel" };
    invoiceKeys.forEach(function (key) { attrs[key] = d.enabled ? (d.values[key] || "").trim() : ""; });
    return attrs;
  }
  function invoiceStatus(message, error) {
    qsa("[data-invoice-status]").forEach(function (el) { el.textContent = message; el.classList.toggle("is-error", !!error); });
  }
  function validateInvoice(root) {
    var box = qs("[data-invoice]", root);
    if (!box) return true;
    captureInvoice(box);
    var first = null;
    qsa("[data-invoice-field]", box).forEach(function (input) {
      var invalid = invoiceDraft.enabled && !input.value.trim();
      input.setAttribute("aria-invalid", invalid ? "true" : "false");
      if (invalid && !first) first = input;
    });
    if (first) { invoiceStatus(box.dataset.error, true); first.focus(); return false; }
    return true;
  }
  document.addEventListener("input", function (e) {
    if (!e.target.matches("[data-invoice-field]")) return;
    captureInvoice(e.target.closest("[data-invoice]"));
    e.target.removeAttribute("aria-invalid");
    invoiceStatus("", false);
    paintInvoice();
    var box = e.target.closest("[data-invoice]");
    clearTimeout(invoiceSaveTimer);
    invoiceSaveTimer = setTimeout(function () { saveInvoiceDraft(box); }, 350);
  });
  document.addEventListener("change", function (e) {
    if (!e.target.matches("[data-invoice-toggle], [data-invoice-field]")) return;
    var box = e.target.closest("[data-invoice]");
    captureInvoice(box);
    paintInvoice();
    invoiceStatus("", false);
    saveInvoiceDraft(box);
  });
  function cartNoteHTML(cart) {
    var old = qs("[data-cart-drawer] .cart-options");
    var template = qs("#cart-options-template");
    if (!template) return "";
    var holder = document.createElement("div");
    holder.appendChild(template.content.cloneNode(true));
    var field = qs("[data-cart-note]", holder);
    var previous = old && qs("[data-cart-note]", old);
    field.textContent = previous ? previous.value : cart.note || "";
    ["[data-note-option]", "[data-discount-option]"].forEach(function (selector) {
      var before = old && qs(selector, old);
      if (before && before.open) qs(selector, holder).open = true;
    });
    if (!invoiceDraft) invoiceDraft = invoiceFromCart(cart);
    paintInvoice(holder);
    return holder.innerHTML;
  }
  function codeApplications(cart) {
    var apps = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) { apps.push(allocation.discount_application); });
    });
    return apps.filter(function (app) { return app && app.type === "discount_code"; });
  }
  function syncCartOptions(cart) {
    latestCart = cart;
    if (!invoiceDraft) invoiceDraft = invoiceFromCart(cart);
    paintInvoice();
    qsa("[data-cart-shipping]").forEach(function (el) {
      el.textContent = cart.total_price > settings.freeShippingThreshold ? el.dataset.freeLabel : el.dataset.paidLabel;
    });
    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable !== false; }).map(function (c) { return c.code; });
    if (!codes.length) codes = codeApplications(cart).map(function (app) { return app.title; });
    qsa(".cart-options").forEach(function (box) {
      var input = qs("[data-discount-input]", box);
      if (input && document.activeElement !== input) input.value = Array.from(new Set(codes)).join(", ");
      var remove = qs("[data-discount-remove]", box);
      if (remove) remove.hidden = !codes.length;
    });
    qsa("[data-cart-original]").forEach(function (el) { el.textContent = formatMoney(cart.original_total_price); });
    qsa("[data-cart-total]").forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    qsa("[data-cart-savings-row]").forEach(function (el) { el.hidden = !cart.total_discount; });
    qsa("[data-cart-savings]").forEach(function (el) { el.textContent = "−" + formatMoney(cart.total_discount); });
  }
  function discountStatus(box, message, error) {
    var status = qs("[data-discount-status]", box);
    status.textContent = message;
    status.classList.toggle("is-error", !!error);
    qs("[data-discount-input]", box).setAttribute("aria-invalid", error ? "true" : "false");
  }
  function applyCartDiscount(button, remove) {
    if (discountBusy || checkoutBusy) return;
    var box = button.closest(".cart-options");
    var inDrawer = !!box.closest("[data-cart-drawer]");
    var input = qs("[data-discount-input]", box);
    var code = remove ? "" : input.value.trim();
    if (!remove && !code) { discountStatus(box, cartUi.discount_empty, true); input.focus(); return; }
    discountBusy = true;
    button.disabled = true;
    discountStatus(box, cartUi.discount_loading, false);
    var note = qs("[data-cart-note]", box).value;
    updateCart({ discount: code, note: note }).then(function (cart) {
      if (inDrawer) renderDrawer(cart); else syncCartOptions(cart);
      box = inDrawer ? qs("[data-cart-drawer] .cart-options") : box;
      qs("[data-discount-option]", box).open = true;
      var requested = code.split(",").map(function (c) { return c.trim().toLowerCase(); });
      var applied = codeApplications(cart).some(function (app) { return requested.indexOf(String(app.title).toLowerCase()) !== -1; });
      var accepted = (cart.discount_codes || []).some(function (c) { return requested.indexOf(String(c.code).toLowerCase()) !== -1 && c.applicable; });
      var success = applied || accepted;
      discountStatus(box, remove ? cartUi.discount_removed : success ? cartUi.discount_success : cartUi.discount_invalid, !remove && !success);
      if (!remove && !success) qs("[data-discount-input]", box).value = code;
      qs("[data-discount-apply]", box).focus();
    }).catch(function () { discountStatus(box, cartUi.discount_error, true); })
      .finally(function () { discountBusy = false; button.disabled = false; });
  }

  var cartExtrasRequest = 0;
  function refreshCartExtras() {
    var request = ++cartExtrasRequest;
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
    return fetch(root + "cart?section_id=cart-stone", { credentials: "same-origin", cache: "no-store" })
      .then(function (response) { if (!response.ok) throw new Error("Cart section unavailable"); return response.text(); })
      .then(function (html) {
        if (request !== cartExtrasRequest) return;
        var section = new DOMParser().parseFromString(html, "text/html");
        var extras = section.querySelector(".plant-extras");
        qsa("[data-cart-extras]").forEach(function (slot) { slot.innerHTML = extras ? extras.outerHTML : ""; });
      }).catch(function () {});
  }
  function renderDrawer(cart) {
    var body = qs("[data-drawer-body]");
    var foot = qs("[data-drawer-foot]");
    if (!body) return;
    var previousScrollTop = body.scrollTop;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Sepetiniz şu an boş.</p></div>';
      if (foot) foot.innerHTML = '<a class="btn btn--outline btn--full" href="/collections/all">Alışverişe Başla</a>';
    } else {
      var summary = document.createElement("div");
      summary.appendChild(qs("#cart-summary-template").content.cloneNode(true));
      qs(".cart-options", summary).outerHTML = cartNoteHTML(cart);
      qs("[data-cart-extras]", summary).innerHTML = "";
      body.innerHTML = freeShippingHTML(cart.total_price) + cart.items.map(drawerLineHTML).join("") + summary.innerHTML;
      if (foot) foot.innerHTML = qs("#cart-payment-template").innerHTML;
    }
    if (foot) foot.hidden = false;
    body.scrollTop = previousScrollTop;
    updateCount(cart.item_count);
    syncCartOptions(cart);
    refreshCartExtras();
  }

  function updateCount(count) {
    qsa("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "grid" : "none";
    });
  }

  function refreshDrawer(open) {
    if (open && window.matchMedia("(min-width: 990px)").matches) {
      var root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
      window.location.assign(root + "cart");
      return Promise.resolve();
    }
    return getCart().then(function (cart) {
      renderDrawer(cart);
      if (open) openDrawer();
      /* Sepete bagli bloklar (hediye baraji) tek bir yerden haber alsin. */
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      return cart;
    });
  }

  /* Sipariş/hediye notu — /cart/update.js ile kaydedilir, checkout'a oradan taşınır.
     Sepet sayfasındaki alan form ile de gönderiliyor; buradaki kayıt anlık geri
     bildirim içindir, ikisi aynı cart.note alanını yazar. */
  function saveCartNote(field) {
    var status = field.closest(".cart-note").querySelector("[data-cart-note-status]");
    if (status) status.textContent = cartUi.saving;
    return updateCart({ note: field.value }).then(function () {
      if (status) status.textContent = cartUi.note_saved;
    }).catch(function () { if (status) status.textContent = cartUi.note_error; });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches("[data-discount-input]")) {
      e.preventDefault(); applyCartDiscount(qs("[data-discount-apply]", e.target.closest(".cart-options")), false);
    }
  });
  document.addEventListener("click", function (e) {
    var apply = e.target.closest("[data-discount-apply], [data-discount-remove]");
    if (apply) { e.preventDefault(); applyCartDiscount(apply, apply.hasAttribute("data-discount-remove")); }
    var checkout = e.target.closest("[data-cart-checkout]");
    if (!checkout || checkout.tagName !== "A") return;
    e.preventDefault();
    if (discountBusy || checkoutBusy) return;
    if (!validateInvoice(checkout.closest("[data-cart-drawer]"))) return;
    checkoutBusy = true;
    checkout.setAttribute("aria-disabled", "true");
    var field = qs("[data-cart-note]", checkout.closest("[data-cart-drawer]"));
    updateCart({ note: field ? field.value : "", attributes: invoiceAttributes() }).then(function () { window.location.assign(checkout.href); })
      .catch(function () { showToast(cartUi.note_error); })
      .finally(function () { checkoutBusy = false; checkout.removeAttribute("aria-disabled"); });
  });
  document.addEventListener("submit", function (e) {
    if (!e.target.matches(".cart-layout")) return;
    if (e.target.dataset.checkoutReady === "true") return;
    e.preventDefault();
    if (discountBusy || checkoutBusy) return;
    if (!validateInvoice(e.target)) return;
    checkoutBusy = true;
    var form = e.target;
    var field = qs("[data-cart-note]", form);
    updateCart({ note: field ? field.value : "", attributes: invoiceAttributes() }).then(function () {
      form.dataset.checkoutReady = "true";
      form.requestSubmit(qs("[data-cart-checkout]", form));
    }).catch(function () { showToast(cartUi.note_error); })
      .finally(function () { checkoutBusy = false; });
  });

  document.addEventListener("change", function (e) {
    var noteField = e.target.closest ? e.target.closest("[data-cart-note]") : null;
    if (noteField) saveCartNote(noteField);
  });

  /* ---------- Delegated events ---------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var openBtn = e.target.closest("[data-open-cart]");
    if (openBtn) { e.preventDefault(); refreshDrawer(true); return; }

    var closeBtn = e.target.closest("[data-drawer-close]");
    if (closeBtn) { closeDrawer(); return; }
    if (e.target.closest("[data-drawer-overlay]")) { closeDrawer(); return; }

    var quick = e.target.closest("[data-quick-add]");
    if (quick) {
      quick.disabled = true;
      /* Kartta adet yok (hep 1); hızlı bakış modalında [data-qty-scope] içinde
         adet kutusu var, varsa onu kullan. */
      var quickScope = quick.closest("[data-qty-scope]");
      var quickQtyInput = quickScope ? qs("[data-qty]", quickScope) : null;
      var quickQty = quickQtyInput ? Math.max(1, parseInt(quickQtyInput.value, 10) || 1) : 1;
      addItems([{ id: parseInt(quick.getAttribute("data-variant-id"), 10), quantity: quickQty }])
        .then(function () {
          showToast(settings.strings.addedToCart || "Sepete eklendi");
          if (qs("[data-cart-page-marker]")) { window.location.reload(); return; }
          return refreshDrawer(true);
        })
        .catch(function (err) { showToast(err.message); })
        .finally(function () { quick.disabled = false; });
      return;
    }

    var bundleBtn = e.target.closest("[data-bundle-add]");
    if (bundleBtn) {
      bundleBtn.disabled = true;
      addItems([
        { id: parseInt(bundleBtn.getAttribute("data-main-id"), 10), quantity: 1 },
        { id: parseInt(bundleBtn.getAttribute("data-partner-id"), 10), quantity: 1 }
      ])
        .then(function () { showToast(settings.strings.addedToCart || "Set sepete eklendi"); return refreshDrawer(true); })
        .catch(function (err) { showToast(err.message); })
        .finally(function () { bundleBtn.disabled = false; });
      return;
    }

    var qtyBtn = e.target.closest("[data-qty-change]");
    if (qtyBtn) {
      var line = parseInt(qtyBtn.getAttribute("data-line"), 10);
      var dir = parseInt(qtyBtn.getAttribute("data-dir"), 10);
      var input = qs('[data-qty-input][data-line="' + line + '"]', qtyBtn.closest(".cart-line"));
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + dir);
      changeLine(line, next).then(function (cart) {
        if (qtyBtn.closest("[data-cart-drawer]")) renderDrawer(cart);
        else window.location.reload();
      });
      return;
    }

    var removeBtn = e.target.closest("[data-remove]");
    if (removeBtn) {
      changeLine(parseInt(removeBtn.getAttribute("data-line"), 10), 0).then(function (cart) {
        if (removeBtn.closest("[data-cart-drawer]")) renderDrawer(cart);
        else window.location.reload();
      });
      return;
    }

    var menuToggle = e.target.closest("[data-menu-toggle]");
    if (menuToggle) {
      qs("[data-site-nav]").classList.add("is-open");
      document.body.classList.add("nav-locked");
      return;
    }
    var navClose = e.target.closest("[data-nav-close]");
    if (navClose) {
      qs("[data-site-nav]").classList.remove("is-open");
      document.body.classList.remove("nav-locked");
      closeAllNavAccordions();
      return;
    }
    var navParent = e.target.closest("[data-nav-parent]");
    if (navParent && window.matchMedia("(max-width: 1400px)").matches) {
      e.preventDefault();
      var parentItem = navParent.closest(".nav-item");
      var parentToggle = parentItem ? qs("[data-nav-toggle]", parentItem) : null;
      var parentWasOpen = parentItem && parentItem.classList.contains("is-open");
      closeAllNavAccordions();
      if (parentItem && !parentWasOpen) {
        parentItem.classList.add("is-open");
        if (parentToggle) parentToggle.setAttribute("aria-expanded", "true");
      }
      return;
    }

    if (e.target.closest("[data-site-nav] a")) {
      qs("[data-site-nav]").classList.remove("is-open");
      document.body.classList.remove("nav-locked");
      closeAllNavAccordions();
      return;
    }

    var navToggle = e.target.closest("[data-nav-toggle]");
    if (navToggle) {
      var item = navToggle.closest(".nav-item");
      var wasOpen = item.classList.contains("is-open");
      closeAllNavAccordions();
      if (!wasOpen) {
        item.classList.add("is-open");
        navToggle.setAttribute("aria-expanded", "true");
      }
      return;
    }
  });

  function closeAllNavAccordions() {
    qsa(".nav-item.is-open").forEach(function (item) {
      item.classList.remove("is-open");
      var toggle = qs("[data-nav-toggle]", item);
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });
  }

  /* ---------- Mega menü: alt kategori hover'ında promo görselini değiştir ---------- */
  function initNavPromoSwap() {
    qsa("[data-nav-panel]").forEach(function (panel) {
      var promo = qs("[data-nav-promo]", panel);
      if (!promo) return;
      var img = qs("[data-nav-promo-img]", promo);
      var title = qs("[data-nav-promo-title]", promo);
      var description = qs("[data-nav-promo-desc]", promo);
      var defaultImage = promo.getAttribute("data-default-image");
      var defaultTitle = promo.getAttribute("data-default-title");
      var defaultDescription = promo.getAttribute("data-default-description") || "";
      var defaultUrl = promo.getAttribute("data-default-url") || promo.getAttribute("href");

      function setPromo(image, text, details, url) {
        if (img && image) {
          img.src = image;
          img.alt = text || "";
        }
        if (title) title.textContent = text || "";
        if (description) description.textContent = details || "";
        if (url) promo.setAttribute("href", url);
      }
      function resetPromo() { setPromo(defaultImage, defaultTitle, defaultDescription, defaultUrl); }

      qsa("[data-promo-image]", panel).forEach(function (link) {
        var show = function () {
          setPromo(
            link.getAttribute("data-promo-image"),
            link.getAttribute("data-promo-title"),
            link.getAttribute("data-promo-description"),
            link.getAttribute("data-promo-url")
          );
        };
        link.addEventListener("mouseenter", show);
        link.addEventListener("focus", show);
      });

      panel.addEventListener("mouseleave", resetPromo);
      panel.addEventListener("focusout", function (e) {
        if (!panel.contains(e.relatedTarget)) resetPromo();
      });
    });
  }

  document.addEventListener("change", function (e) {
    var input = e.target.closest ? e.target.closest("[data-qty-input]") : null;
    if (input && input.closest("[data-cart-drawer]")) {
      var line = parseInt(input.getAttribute("data-line"), 10);
      changeLine(line, Math.max(0, parseInt(input.value, 10) || 0)).then(renderDrawer);
    }
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---------- Ürün sayfası ---------- */
  function initProductPage() {
    var form = qs("#product-form");
    if (!form) return;

    /* Varyant seçimi */
    var variantsScript = qs("[data-variants-json]");
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var hiddenId = qs("[data-variant-id]", form);

    function currentOptions() {
      var opts = [];
      qsa("[data-option-index]").forEach(function (group) {
        var pressed = qs('[aria-pressed="true"]', group);
        if (pressed) opts.push(pressed.getAttribute("data-value"));
      });
      return opts;
    }
    function syncVariant() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
      if (match) {
        hiddenId.value = match.id;
        var addBtn = qs("[data-add-to-cart]");
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? "Sepete Ekle" : "Tükendi";
        }
        if (match.featured_image) {
          /* Galeri kendi içinde çözüyor: görsel zaten şeritteyse ona kayar,
             değilse ilk slaytı bu görselle değiştirir. */
          document.dispatchEvent(new CustomEvent("gallery:show", { detail: { src: match.featured_image.src } }));
        }
      }
    }
    qsa("[data-option-select]").forEach(function (pill) {
      pill.addEventListener("click", function () {
        var group = pill.closest("[data-option-index]");
        qsa("[data-option-select]", group).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        pill.setAttribute("aria-pressed", "true");
        var label = qs("[data-option-value]", group);
        if (label) label.textContent = pill.getAttribute("data-value");
        syncVariant();
      });
    });

    /* Adet */
    var qty = qs("[data-qty]", form);
    var minus = qs("[data-qty-minus]", form);
    var plus = qs("[data-qty-plus]", form);
    if (minus) minus.addEventListener("click", function () { qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
    if (plus) plus.addEventListener("click", function () { qty.value = parseInt(qty.value, 10) + 1; });

    /* Sabit alt satın-al barı — ana buton görünürken gizli, kaybolunca belirir */
    var stickyBar = qs("[data-sticky-buy]");
    var buyRow = qs(".buy-row");
    if (stickyBar && buyRow && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          /* Mobilde buy-row ~1200px asagida oldugu icin "gorunmuyor" kosulu
             sayfanin en tepesinde de saglaniyordu; bar ilk ekranda aciliyor ve
             urun gorselinin alt 73px'ini kapatiyordu. Bar sadece kullanici
             buy-row'u GECTIYSE (kutu viewport'un ustunde kaldiysa) cikmali. */
          var scrolledPast = en.boundingClientRect.top < 0;
          stickyBar.classList.toggle("is-visible", !en.isIntersecting && scrolledPast);
        });
      }, { rootMargin: "0px 0px -10% 0px" });
      io.observe(buyRow);
    }

    /* AJAX ekleme */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = qs("[data-add-to-cart]", form);
      btn.disabled = true;
      /* Isaretli ek urunler ana urunle AYNI istekte gidiyor: iki ayri
         /cart/add.js cagrisi yapilirsa sepet cekmecesi iki kez yenilenip
         ilk urunu bir an bos gosteriyordu. */
      var items = [{ id: parseInt(hiddenId.value, 10), quantity: Math.max(1, parseInt(qty.value, 10) || 1) }];
      qsa("[data-addon-input]", form).forEach(function (box) {
        if (!box.checked) return;
        var addonId = parseInt(box.value, 10);
        if (addonId) items.push({ id: addonId, quantity: 1 });
      });
      addItems(items)
        .then(function () { showToast(settings.strings.addedToCart || "Sepete eklendi"); return refreshDrawer(true); })
        .catch(function (err) { showToast(err.message); })
        .finally(function () { btn.disabled = false; });
    });

    /* Ürün galerisi.
       Masaüstü: slaytlar üst üste, thumb/ok ile aktif slayt değişir.
       Mobil: slaytlar yan yana, kaydırmayı tarayıcının kendi scroll-snap'i yapar
       (elle touch hesaplamak görselin kaymadığı, aniden değiştiği hissi veriyordu). */
    var slidesTrack = qs("[data-gallery-slides]");
    if (slidesTrack) {
      var slides = qsa(".product-gallery__slide", slidesTrack);
      var thumbs = qsa("[data-thumb]");
      var dots = qsa("[data-gallery-dots] .gallery-dots__dot");
      var counter = qs("[data-gallery-counter]");
      var activeIndex = 0;

      /* Mobilde şerit kaydırılabilir; masaüstünde slaytlar üst üste duruyor. */
      function isScrollMode() {
        return getComputedStyle(slidesTrack).overflowX !== "visible";
      }

      function markActive(i) {
        activeIndex = i;
        slides.forEach(function (s, n) { s.classList.toggle("is-active", n === i); });
        thumbs.forEach(function (b, n) { b.setAttribute("aria-selected", n === i ? "true" : "false"); });
        dots.forEach(function (d, n) { d.classList.toggle("is-active", n === i); });
        if (counter) counter.textContent = i + 1 + "/" + slides.length;
      }

      function goTo(index) {
        var i = (index + slides.length) % slides.length;
        if (isScrollMode()) {
          slidesTrack.scrollTo({ left: i * slidesTrack.clientWidth, behavior: "smooth" });
        }
        markActive(i);
      }

      thumbs.forEach(function (btn, i) {
        btn.addEventListener("click", function () { goTo(i); });
      });

      var prevBtn = qs("[data-gallery-prev]");
      var nextBtn = qs("[data-gallery-next]");
      if (prevBtn) prevBtn.addEventListener("click", function () { goTo(activeIndex - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { goTo(activeIndex + 1); });

      var galleryMain = qs(".product-gallery__main");
      if (galleryMain && slides.length > 1) {
        galleryMain.addEventListener("keydown", function (e) {
          if (e.key === "ArrowLeft") { e.preventDefault(); goTo(activeIndex - 1); }
          if (e.key === "ArrowRight") { e.preventDefault(); goTo(activeIndex + 1); }
        });
      }

      /* Parmakla kaydırılırken nokta ve sayaç anlık takip etsin.
         Hesap ucuz olduğu için doğrudan yapılıyor; rAF ile ertelemek arka plan
         sekmesinde güncellemeyi tamamen durduruyordu. */
      slidesTrack.addEventListener("scroll", function () {
        if (!isScrollMode()) return;
        var w = slidesTrack.clientWidth;
        if (!w) return;
        var i = Math.round(slidesTrack.scrollLeft / w);
        if (i !== activeIndex && slides[i]) markActive(i);
      }, { passive: true });

      /* Varyant değişince: görsel şeritte varsa ona kay, yoksa ilk slaytı değiştir. */
      document.addEventListener("gallery:show", function (e) {
        var src = e.detail && e.detail.src;
        if (!src) return;
        var name = src.split("?")[0].split("/").pop().replace(/_\d+x\d*(?=\.)/, "");
        var found = -1;
        slides.forEach(function (s, n) {
          /* Video/3B slaytlar <div>: src'leri yok, eslesmeye girmiyorlar. */
          if (!s.src) return;
          var slideName = s.src.split("?")[0].split("/").pop().replace(/_\d+x\d*(?=\.)/, "");
          if (found === -1 && slideName === name) found = n;
        });
        if (found !== -1) goTo(found);
        else if (slides[0] && slides[0].src) { slides[0].src = src; goTo(0); }
      });
    }

    /* Benzer ürünler (recommendations section rendering) */
    var related = qs("[data-related-products]");
    if (related && related.children.length === 0 && related.getAttribute("data-url")) {
      fetch(related.getAttribute("data-url"))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var grid = tmp.querySelector("[data-related-products]");
          if (grid && grid.children.length) related.innerHTML = grid.innerHTML;
        })
        .catch(function () {});
    }
  }

  /* Yana kaydırmalı ürün rayları (anasayfa koleksiyon bölümleri) */
  function initProductRails() {
    qsa("[data-rail]").forEach(function (rail) {
      var head = rail.parentNode.querySelector(".section-head--rail");
      if (!head) return;
      var prev = qs("[data-rail-prev]", head);
      var next = qs("[data-rail-next]", head);
      if (!prev || !next) return;

      function step() { return Math.round(rail.clientWidth * 0.9); }

      function syncArrows() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        prev.disabled = rail.scrollLeft <= 0;
        next.disabled = rail.scrollLeft >= max;
      }

      prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
      next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
      rail.addEventListener("scroll", syncArrows, { passive: true });
      window.addEventListener("resize", syncArrows);
      syncArrows();
    });
  }

  /* Koleksiyon filtreleri: mobil aç/kapa + seçim yapınca otomatik uygula */
  function initCollectionFilters() {
    var form = qs("[data-filter-form]") || qs("#collection-filter-form");
    if (!form) return;

    // Bos fiyat alanlari URL'e "?...lte=" olarak eklenmesin. Submit event'ine bagli
    // olmasi sart: "Uygula" butonu native submit yapiyor, JS'i atliyor.
    form.addEventListener("submit", function () {
      qsa("input[type='number']", form).forEach(function (input) {
        if (input.value === "") input.disabled = true;
      });
    });

    function submitFilters() {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    qsa("input[type='checkbox']", form).forEach(function (input) {
      input.addEventListener("change", submitFilters);
    });

    var sort = qs("[data-sort]");
    if (sort) sort.addEventListener("change", submitFilters);

    var toggle = qs("[data-filter-toggle]");
    var panel = qs("[data-filters]");
    if (toggle && panel) {
      toggle.addEventListener("click", function () {
        var open = panel.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
  }

  /* Header'in Shopify bolum sarmalayicisini sticky yapar. CSS'te :has() ile de
     ayni sey yapiliyor; bu, :has desteklemeyen eski tarayicilar icin yedek. */
  /* Header yuksekligini olcup --header-h'ye yazar. Deger CSS'te sabit 72px'ti;
     header'a ust yardimci bar eklenince (22.08) sabit sayi tutmadi ve hero
     overlay hesabi (margin-top: -header-h) kayardi. Olcum hem acilista hem
     yeniden boyutlandirmada, hem de duyuru bandi degisince yapiliyor. */
  function measureHeader() {
    var header = qs(".site-header");
    if (!header) return;
    var h = header.offsetHeight;
    if (h > 0) document.documentElement.style.setProperty("--header-h", h + "px");
  }

  function initHeaderMeasure() {
    measureHeader();
    if (window.ResizeObserver) {
      var header = qs(".site-header");
      if (header) new ResizeObserver(measureHeader).observe(header);
    } else {
      window.addEventListener("resize", measureHeader);
    }
    /* Yazi tipleri gec yuklenince header birkac piksel buyuyor. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHeader);
  }

  function initStickyHeaderWrap() {
    var header = qs(".site-header");
    if (!header || !header.parentElement) return;
    header.parentElement.classList.add("header-sticky-wrap");
  }

  /* Yapiskan duyuru bandi: sarmalayicisini sticky yapar (CSS'te :has() ile de
     yapiliyor, bu eski tarayici yedegi) ve yuksekligini --announcement-h'ye
     yazar. Header o kadar asagidan yapisir, aksi halde ikisi ust uste biner.
     Yukseklik yazi boyuna ve kirilima gore degisiyor, sabit sayi tutmuyor. */
  function initStickyAnnouncement() {
    var bar = qs(".marquee--sticky");
    if (!bar) return;
    if (bar.parentElement) bar.parentElement.classList.add("announcement-sticky-wrap");

    function sync() {
      document.documentElement.style.setProperty("--announcement-h", bar.offsetHeight + "px");
      measureHeader();
    }
    sync();
    if (window.ResizeObserver) new ResizeObserver(sync).observe(bar);
    else window.addEventListener("resize", sync);
  }

  /* Saydam (overlay) header'i sayfa kaydirilinca opak duruma gecirir.
     Sadece ana sayfada (body.header-overlay) calisir. */
  function initOverlayHeader() {
    if (!document.body.classList.contains("header-overlay")) return;
    var header = qs(".site-header");
    if (!header) return;

    var STUCK_AFTER = 48;
    var ticking = false;

    function sync() {
      header.classList.toggle("is-stuck", window.scrollY > STUCK_AFTER);
      ticking = false;
    }

    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  }

  /* Koleksiyon listesinde sonsuz kaydirma. Buton gorunur alana girince bir
     sonraki sayfa cekilir ve kartlar mevcut izgaraya eklenir. Kart icindeki
     galeri/sepet olaylari document seviyesinde delege oldugu icin eklenen
     kartlar ek bir baglama gerektirmez. */
  function initInfiniteScroll() {
    var grid = qs("[data-infinite-grid]");
    var wrap = qs("[data-infinite-more]");
    if (!grid || !wrap) return;

    var link = qs("[data-infinite-next]", wrap);
    var status = qs("[data-infinite-status]", wrap);
    var strings = (window.theme && window.theme.strings) || {};
    var loading = false;
    var io = null;

    function setStatus(text) {
      if (status) status.textContent = text || "";
    }

    function finish() {
      wrap.remove();
      setStatus("");
    }

    function loadNext() {
      if (loading || !link) return;
      var url = link.getAttribute("href");
      if (!url) return;

      loading = true;
      link.setAttribute("aria-busy", "true");
      setStatus(strings.loading || "");

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var nextGrid = doc.querySelector("[data-infinite-grid]");
          if (nextGrid) {
            var cards = nextGrid.children;
            while (cards.length) grid.appendChild(cards[0]);
          }

          var nextLink = doc.querySelector("[data-infinite-next]");
          if (nextLink) {
            link.setAttribute("href", nextLink.getAttribute("href"));
            setStatus("");
          } else {
            finish();
          }
        })
        .catch(function () {
          /* Ag hatasinda buton normal sayfa baglantisi olarak kullanilabilir kalsin */
          setStatus("");
        })
        .finally(function () {
          loading = false;
          if (link) link.removeAttribute("aria-busy");
          /* Buton hala ekrandaysa IntersectionObserver yeni bir olay uretmez;
             yeniden gozlemleyerek bir sonraki sayfayi da tetikliyoruz. */
          if (io && wrap.isConnected) {
            io.unobserve(wrap);
            io.observe(wrap);
          }
        });
    }

    link.addEventListener("click", function (e) {
      e.preventDefault();
      loadNext();
    });

    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: "600px 0px" });
      io.observe(wrap);
    }
  }

  /* Header'da acilir arama paneli. Shopify'in predictive search ucundan
     (/search/suggest.json) yazdikca sonuc ceker; kullanici sayfadan ayrilmaz. */
  function initSearchPanel() {
    var panel = qs("[data-search-panel]");
    var toggle = qs("[data-search-toggle]");
    if (!panel || !toggle) return;

    var input = qs("[data-search-input]", panel);
    var results = qs("[data-search-results]", panel);
    var form = qs("form", panel);
    var strings = (window.theme && window.theme.strings) || {};
    var timer = null;
    var lastQuery = "";

    function open() {
      panel.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      document.body.classList.add("search-open");
      if (input) input.focus();
    }

    function close() {
      panel.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("search-open");
    }

    function escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML = '<p class="search-results__empty">' + escapeHtml(strings.noResults || "") + "</p>";
        return;
      }

      var html = products
        .map(function (p) {
          /* Ham gorsel 1200x1800 geliyor; 52px kutu icin CDN'den kucuk boyut iste. */
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : "";
          if (img) img += (img.indexOf("?") === -1 ? "?" : "&") + "width=104";

          /* DIKKAT: /search/suggest.json fiyati KURUS degil, ondalik string
             dondurur ("324.99"). formatMoney kurus bekliyor, 100 ile carp. */
          var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : "";
          return (
            '<a class="search-result" href="' + escapeHtml(p.url) + '">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="" width="52" height="52">' : '<span class="search-result__noimg"></span>') +
            '<span class="search-result__text">' +
            '<span class="search-result__title">' + escapeHtml(p.title) + "</span>" +
            (price ? '<span class="search-result__price">' + price + "</span>" : "") +
            "</span></a>"
          );
        })
        .join("");

      html +=
        '<a class="search-results__all" href="/search?q=' + encodeURIComponent(query) + '">' +
        escapeHtml(strings.viewAll || "") + " &rarr;</a>";

      results.innerHTML = html;
    }

    function search(query) {
      var url =
        "/search/suggest.json?q=" + encodeURIComponent(query) +
        "&resources[type]=product&resources[limit]=6";

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (query !== lastQuery) return; /* daha yeni bir sorgu var */
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, query);
        })
        .catch(function () {
          results.innerHTML = "";
        });
    }

    toggle.addEventListener("click", function () {
      if (panel.hidden) open(); else close();
    });

    var closeBtn = qs("[data-search-close]", panel);
    if (closeBtn) closeBtn.addEventListener("click", close);

    if (input) {
      input.addEventListener("input", function () {
        var query = input.value.trim();
        lastQuery = query;
        clearTimeout(timer);

        if (query.length < 2) {
          results.innerHTML = "";
          return;
        }

        results.innerHTML = '<p class="search-results__empty">' + escapeHtml(strings.searching || "") + "</p>";
        timer = setTimeout(function () { search(query); }, 250);
      });
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        if (!input || input.value.trim() === "") e.preventDefault();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panel.hidden) close();
    });

    document.addEventListener("click", function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });
  }

  /* Sayfa başına dön: bir ekran boyu kaydırılınca beliriyor. Scroll olayı
     rAF ile kısılıyor, aksi halde her tik'te layout okunuyor. */
  function initBackToTop() {
    var btn = document.querySelector("[data-back-to-top]");
    if (!btn) return;
    btn.hidden = false;
    var ticking = false;
    function update() {
      ticking = false;
      btn.classList.toggle("is-visible", window.scrollY > window.innerHeight);
    }
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    btn.addEventListener("click", function () {
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initProductPage();
    initStickyHeaderWrap();
    initHeaderMeasure();
    initStickyAnnouncement();
    initOverlayHeader();
    initInfiniteScroll();
    initSearchPanel();
    initNavPromoSwap();
    initProductRails();
    initCollectionFilters();
    initBackToTop();
    getCart().then(function (cart) { updateCount(cart.item_count); syncCartOptions(cart); }).catch(function () {});
  });

  /* Kardeş ürün geçişi bölümü değiştirince ürün sayfası bağlarını yeniden kur */
  document.addEventListener("product:section-replaced", initProductPage);
})();







